/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import {
  Titulo,
  Boton,
  accessAPI,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

const SEARCH_FIELDS = ["descripcion", "correos"];

export default function Eventos() {
  const [loader, setLoader] = useState(true);
  const [eventoTipos, setEventoTipos] = useState([]);

  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Eventos";
    accessAPI(
      "GET",
      "admin/comunicacion/eventotipos",
      null,
      (respuesta) => {
        setEventoTipos(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar eventos",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRowClick = (e) => {
    if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
      window.open(`/comunicacion/configeventos/${e.data.id}`, "_blank");
    } else {
      navigate(`/comunicacion/configeventos/${e.data.id}`);
    }
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.5rem"
            }}
          >
            <Skeleton width="15rem" height="2.5rem" />
          </div>
          <Card>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton uri="/comunicacion/enviados">
                Enviados
              </Boton>
            }
          >
            Eventos
          </Titulo>

          <Card>
            <TablaFiltrable
              value={eventoTipos}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="eventos"
              emptyMessage="No hay eventos configurados"
              onRowClick={onRowClick}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Descripción" field="descripcion" />
              <Column
                header=""
                body={(evento) =>
                  evento.cuentaConfig > 0 ? (
                    <i
                      className="pi pi-envelope"
                      css={{ color: "var(--principal)", fontSize: "1.2rem" }}
                    />
                  ) : null
                }
                style={{ width: "60px", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
